export default "__VITE_ASSET__SS9JvL89__"